import { atom } from 'recoil';
import { recoilPersist } from 'recoil-persist'

const { persistAtom } = recoilPersist()


export const lpaManagementDetailsState = atom({
  key: 'lpaManagementDetailsState',
  default: {
    LPAQuestions: [],
    responses: [],
    totalScore: []
  },
  effects_UNSTABLE: [persistAtom],
});